import { useEffect } from 'react';
import Pusher from 'pusher-js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TaskListener = () => {
  useEffect(() => {
    // Request notification permission on component mount
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }

    const pusher = new Pusher('60ff6d3b0dba5a778b99', {
      cluster: 'eu',
    });

    const channel = pusher.subscribe('task-channel');

    channel.bind('task-completed', function (data) {
      // Show toast
      toast.info(
        `📘 ${data.type.toUpperCase()} — ${data.message}`,
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );


      // Browser notification
      if (Notification.permission === 'granted') {
        new Notification(`✅ ${data.type}`, {
          body: data.message,
          icon: '/notification-icon.png',
        });
      }

      console.log('Pusher event received:', data);
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, []);

  return null;
};

export default TaskListener;
